import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import FormInfo from "components/haven-design/form/info";
import Header from "components/header";
import { Footer } from "../layout";

const FormCompleted: React.FC<RouteComponentProps> = () => (
  <>
    <Header />
    <div className="container">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInfo title="Form completed" type="Success">
            <Typography align="center" variant="body1">
              <br />
              <span style={{ fontSize: 32 }} className="fa fa-thumbs-up" />
              <br />
              <br />
              You&apos;ve already completed the form!
            </Typography>
          </FormInfo>
        </Grid>
      </Grid>
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
        <Footer />
      </div>
    </div>
  </>
);

export default FormCompleted;
